<header *ngIf="!canAccess" [ngClass]="{ 'mnc-header': isIos }" class="bg-white sticky-top">
  <app-enviroment-state></app-enviroment-state>
  <div class="navbar navbar-expand-lg px-1 px-xl-3">
    <div class="container px-1 px-xl-3"> 

      <!-- Mobile offcanvas menu toggler (Hamburger) -->
      <button
        *ngIf="this.privateMode"
        type="button"
        class="navbar-toggler me-3 me-lg-0"
        (click)="openNavbar()"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar brand (Logo) -->
      <a class="navbar-brand py-1 py-md-2 py-xl-2 me-2 me-sm-n4 me-md-n5 me-lg-0" [routerLink]="['/home']">
        <!-- [src]="logoHeader || 'assets/placeholder.png'" Un logo estático para evitar el parpadeo -->
        <img
          class="d-block"
          [src]="this.logoHeader || this.configService.companyConfig.logo.base"
          width="170" height="35" alt="Logotipo cabecera programa Málaga no caduca"
        />
      </a>

      <!-- Navegación principal que se convierte en offcamvas en pantallas <992 px de ancho (lg breakpoint) -->
      <nav *ngIf="this.privateMode" class="offcanvas offcanvas-start safe-area" id="navbarNav" tabindex="-1"
        aria-labelledby="navbarNavLabel" aria-label="Menú principal">
        <div class="offcanvas-header py-3">
          <h5 class="offcanvas-title" id="navbarNavLabel">
            <img
              class="d-block"
              src="{{ this.configService.companyConfig.logo.base }}"
              width="125"
              alt="Málaga no caduca"
            />
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i class="bi bi-x-circle-fill h1 text-primary"></i>
          </button>
        </div>
        <div class="offcanvas-body pt-2 pb-4 py-lg-0 mx-lg-auto">
          <ul class="navbar-nav position-relative">
            <li class="nav-item dropdown py-lg-2 me-lg-n1 me-xl-0">
              <a
                class="nav-link"
                [attr.aria-current]="isActive('/auth-home') ? 'page' : null"
                data-bs-dismiss="offcanvas"
                [routerLink]="['/auth-home']"
                [class.active]="isActive('/auth-home')"
              >
                <i class="bi bi-house me-2 d-flex d-md-none" aria-hidden="true"></i>
                {{"donants.shared.header.home" | translate}}
              </a>
            </li>

            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0" >
              <a
                class="nav-link"
                [attr.aria-current]="isActive('/profile') ? 'page' : null"
                data-bs-dismiss="offcanvas"
                [routerLink]="['/profile']"
                [class.active]="isActive('/profile')"
              >
                <i class="bi bi-person-vcard me-2 d-flex d-md-none" aria-hidden="true"></i>
                {{"donants.shared.header.myData" | translate}}
              </a>
            </li>

            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0" >
              <a
                class="nav-link"
                [attr.aria-current]="isActive('/documents-list') ? 'page' : null"
                data-bs-dismiss="offcanvas"
                [routerLink]="['/documents-list']"
                [class.active]="isActive('/documents-list')"
              >
                <i class="bi bi-file-earmark-text me-2 d-flex d-md-none" aria-hidden="true"></i>
                {{"donants.shared.header.documents" | translate}}
              </a>
            </li>

            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0" >
              <a
                class="nav-link"
                [attr.aria-current]="isActive('/products') ? 'page' : null"
                data-bs-dismiss="offcanvas"
                [routerLink]="['/products']"
                [class.active]="isActive('/products')"
              >
                <i class="bi bi-fork-knife me-2 d-flex d-md-none" aria-hidden="true"></i>
                {{"donants.shared.header.myProducts" | translate}}
              </a>
            </li>

            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0">
              <a
                class="nav-link"
                [attr.aria-current]="isActive('/donation-list') ? 'page' : null"
                data-bs-dismiss="offcanvas"
                [routerLink]="['/donation-list']"
                [class.active]="isActive('/donation-list')"
              >
                <i class="bi bi-box2-heart me-2 d-flex d-md-none" aria-hidden="true"></i>
                {{"donants.shared.header.donations" | translate}}
              </a>
            </li>

            <li class="nav-item py-lg-2 me-lg-n2 me-xl-0" >
              <a
                class="nav-link"
                [attr.aria-current]="isActive(['/help','/contact']) ? 'page' : null"
                data-bs-dismiss="offcanvas"
                [routerLink]="['/help']"
                [class.active]="isActive(['/help','/contact'])"
              >
                <i class="bi bi-question-circle me-2 d-flex d-md-none" aria-hidden="true"></i>
                {{"donants.shared.header.help" | translate}}
              </a>
            </li>

            <li *ngIf="isNative" class="nav-item mt-auto px-3 app-version">
              <small class="text-muted">{{ appVersion$ | async }}</small>
            </li>

          </ul>
        </div>
      </nav>

      <!-- Button group pública -->
      <div *ngIf="!this.privateMode" class="d-flex gap-sm-1">

        <!-- Quiero ser donante -->
        <a class="btn bg-dark animate-scale text-white rounded-circle rounded-lg-2 p-2 p-lg-btn me-2" 
        href="https://sede.malaga.es/ied-malaga-no-caduca-adhesion-de-empresas/"
        target="_blank" rel="noopener noreferrer">
          <i class="bi bi-person-heart fs-lg animate-target ms-lg-n2 me-lg-1 p-015 p-lg-0"></i>
          <span class="d-none d-lg-inline ms-1">{{"donants.shared.header.wantToBeDonor" | translate}}</span>
        </a>

        <!-- Acceder a MNC -->
        <button class="btn btn-primary animate-shake me-2 rounded-circle rounded-lg-2 p-2 p-lg-btn" (click)="logIn()">
          <i class="bi bi-person-plus fs-lg animate-target ms-lg-n2 me-lg-1 p-015 p-lg-0"></i>
          <span class="d-none d-lg-inline ms-1">{{"donants.shared.header.imADonor" | translate}}</span>
        </button>

        <!-- AYUDA  -->
        <a
          class="btn bg-secondary animate-scale text-white rounded-circle rounded-lg-2 p-2 p-lg-btn"
          [routerLink]="['/help']"
        >
          <i
            class="bi bi-question-circle fs-lg animate-target ms-lg-n2 me-lg-1 p-015 p-lg-0"
          ></i>
          <span class="d-none d-lg-inline ms-1">{{
            "donants.shared.header.help" | translate
          }}</span>
        </a>
      </div>

      <div *ngIf="this.privateMode" class="d-flex gap-sm-1">
        <!-- SALIR / DESCONECTAR  -->
        <button
          class="btn btn-icon animate-shake position-relative bg-primary rounded-circle overflow-hidden d-flex align-items-center ms-2"
          role="button"
          aria-expanded="false"
          aria-label="Salir"
          (click)="this.logOut()"
        >
          <i class="bi bi-box-arrow-left h5 pb-0 mb-0 text-white fw-normal"></i>
        </button>
      </div>
    </div>
  </div>
</header>
